import { render } from "./App.vue?vue&type=template&id=ac134284"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=ac134284&lang=css"

import exportComponent from "/Users/rahila/Development/ministryofhealth/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__